/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Footer_TaglineInputs */

const en_landing_footer_tagline = /** @type {(inputs: Landing_Footer_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Change one thing. Keep everything else.`)
};

const zh_landing_footer_tagline = /** @type {(inputs: Landing_Footer_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`只改一处，其余照旧。`)
};

/**
* | output |
* | --- |
* | "Change one thing. Keep everything else." |
*
* @param {Landing_Footer_TaglineInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_footer_tagline = /** @type {((inputs?: Landing_Footer_TaglineInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Footer_TaglineInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_footer_tagline(inputs)
	return zh_landing_footer_tagline(inputs)
});
export { landing_footer_tagline as "landing.footer.tagline" }